import { App } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import type { NotificationInstance } from 'antd/es/notification/interface';
import type { PropsWithChildren } from 'react';

let messageInstance: MessageInstance | null = null;
let notificationInstance: NotificationInstance | null = null;

const AntdAppRegistrar = () => {
  const app = App.useApp();

  messageInstance = app.message;
  notificationInstance = app.notification;

  return null;
};

export const AntdAppProvider = ({ children }: PropsWithChildren) => {
  return (
    <App>
      <AntdAppRegistrar />
      {children}
    </App>
  );
};

export const antdApp = {
  message: {
    success: (...args: Parameters<MessageInstance['success']>) =>
      messageInstance?.success(...args),
    error: (...args: Parameters<MessageInstance['error']>) =>
      messageInstance?.error(...args),
    info: (...args: Parameters<MessageInstance['info']>) =>
      messageInstance?.info(...args),
    warning: (...args: Parameters<MessageInstance['warning']>) =>
      messageInstance?.warning(...args),
    loading: (...args: Parameters<MessageInstance['loading']>) =>
      messageInstance?.loading(...args),
    open: (...args: Parameters<MessageInstance['open']>) =>
      messageInstance?.open(...args),
    destroy: (...args: Parameters<MessageInstance['destroy']>) =>
      messageInstance?.destroy(...args),
  },
  notification: {
    success: (...args: Parameters<NotificationInstance['success']>) =>
      notificationInstance?.success(...args),
    error: (...args: Parameters<NotificationInstance['error']>) =>
      notificationInstance?.error(...args),
    info: (...args: Parameters<NotificationInstance['info']>) =>
      notificationInstance?.info(...args),
    warning: (...args: Parameters<NotificationInstance['warning']>) =>
      notificationInstance?.warning(...args),
    open: (...args: Parameters<NotificationInstance['open']>) =>
      notificationInstance?.open(...args),
    destroy: (...args: Parameters<NotificationInstance['destroy']>) =>
      notificationInstance?.destroy(...args),
  },
};
